import { render, staticRenderFns } from "./BaseSelectYesNo.vue?vue&type=template&id=6c45aac7&"
import script from "./BaseSelectYesNo.vue?vue&type=script&lang=js&"
export * from "./BaseSelectYesNo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports